const Arbitrum = () => (
    <svg
        width='1122'
        height='1122'
        viewBox='0 0 1122 1122'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <circle cx='561' cy='561' r='561' fill='white' />
        <path
            d='M179.304 379.219V744.421C179.304 767.898 191.601 789.14 212.097 801.065L528.481 983.666C548.605 995.218 573.573 995.218 593.696 983.666L910.08 801.065C930.203 789.512 942.874 767.898 942.874 744.421V379.219C942.874 355.742 930.576 334.501 910.08 322.576L593.696 139.975C573.573 128.422 548.605 128.422 528.481 139.975L212.097 322.576C191.974 334.128 179.676 355.742 179.676 379.219H179.304Z'
            fill='#213147'
        />
        <path
            d='M629.843 632.627L584.752 756.348C583.634 759.702 583.634 763.428 584.752 767.155L662.264 979.941L752.074 928.142L644.376 632.627C641.768 625.919 632.451 625.919 629.843 632.627Z'
            fill='#12AAFF'
        />
        <path
            d='M720.397 424.683C717.788 417.975 708.472 417.975 705.863 424.683L660.772 548.405C659.654 551.759 659.654 555.485 660.772 559.212L787.847 907.644L877.657 855.845L720.397 425.056V424.683Z'
            fill='#12AAFF'
        />
        <path
            d='M560.902 153.762C563.138 153.762 565.374 154.507 567.237 155.625L909.334 353.132C913.433 355.368 915.669 359.84 915.669 364.312V759.326C915.669 763.798 913.061 768.27 909.334 770.506L567.237 968.013C565.374 969.131 563.138 969.876 560.902 969.876C558.666 969.876 556.43 969.131 554.567 968.013L212.469 770.506C208.37 768.27 206.134 763.798 206.134 759.326V363.939C206.134 359.467 208.743 354.995 212.469 352.759L554.567 155.252C556.43 154.134 558.666 153.389 560.902 153.389V153.762ZM560.902 96C548.604 96 536.679 98.9812 525.5 105.316L183.402 302.824C161.416 315.494 148 338.598 148 363.939V758.953C148 784.294 161.416 807.398 183.402 820.069L525.5 1017.58C536.307 1023.91 548.604 1026.89 560.902 1026.89C573.199 1026.89 585.124 1023.91 596.304 1017.58L938.401 820.069C960.388 807.398 973.803 784.294 973.803 758.953V363.939C973.803 338.598 960.388 315.494 938.401 302.824L595.931 105.316C585.124 98.9812 572.827 96 560.529 96H560.902Z'
            fill='#9DCCED'
        />
        <path
            d='M334.327 908.015L366.003 821.559L429.354 874.103L370.102 928.511L334.327 908.015Z'
            fill='#213147'
        />
        <path
            d='M531.836 335.99H445.007C438.672 335.99 432.709 340.089 430.473 346.052L244.519 855.844L334.328 907.643L539.289 346.052C541.152 340.834 537.425 335.617 532.208 335.617L531.836 335.99Z'
            fill='white'
        />
        <path
            d='M683.878 335.99H597.049C590.714 335.99 584.752 340.089 582.516 346.052L370.103 928.139L459.912 979.938L690.959 346.052C692.822 340.834 689.095 335.617 683.878 335.617V335.99Z'
            fill='white'
        />
    </svg>
);

export default Arbitrum;
